/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import update from"./_update";const methodize=function(e){return e._methodized||(e._methodized=function(){let t=update([this],arguments);return e(...t)}),e._methodized};export default methodize;